// jason - 04062026
document.addEventListener('teeinblue-event-component-injected', function () {
  function moveElement(sourceSelector, targetSelector, position = 'after') {
    const source = document.querySelector(sourceSelector);
    const target = document.querySelector(targetSelector);

    if (!source || !target) return;

    if (position === 'before') {
      target.before(source);
    } else {
      target.after(source);
    }
  }

  moveElement('.tee-btn--preview', '.product-form__buttons .product-form__submit', 'before');
});

// jason - 05012026
(function () {

   /**
   * ================= CONFIG =================
   * Các selector dành riêng cho AOV Cart Drawer
   */
  const SELECTORS = {
    drawer: '#aov-cart-drawer',              // root container của cart drawer
    openClass: 'AOV-CartDrawer--open',       // class khi drawer mở
    item: '.AOV-CartDrawer-Item',            // mỗi line item trong cart
    itemContent: '.AOV-CartDrawer-ItemContent', // nơi append preview button
    marker: '.tee-preview-design'            // element preview đã inject
  };

  const DEBOUNCE_DELAY = 300;     // debounce để tránh spam logic khi DOM update liên tục
  const CART_CACHE_TTL = 1000;    // cache /cart.js trong 1s để giảm fetch
  const MAX_RETRY = 3;            // retry khi item render chậm

  let itemObserver = null;
  let isObservingItems = false;
  let isFetching = false;

  let cachedCart = null;
  let lastFetchTime = 0;

  let drawerClassObserver = null;

  /**
   * Debounce async function + lock tránh gọi song song
   */
  function debounceAsync(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        if (isFetching) return;
        isFetching = true;
        try {
          await fn.apply(this, args);
        } finally {
          isFetching = false;
        }
      }, delay);
    };
  }

  /**
   * Fetch Shopify cart với cache ngắn hạn
   */
  async function getCart() {
    const now = Date.now();

    // dùng cache nếu còn hạn
    if (cachedCart && now - lastFetchTime < CART_CACHE_TTL) {
      return cachedCart;
    }

    const res = await fetch('/cart.js');
    cachedCart = await res.json();
    lastFetchTime = now;

    return cachedCart;
  }
  
  /**
   * Delay helper (dùng để stagger từng item)
   */
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Revalidate nút preview sau khi render
   * Vì nhiều cart drawer sẽ:
   * - reuse DOM node
   * - update lại image sau
   * → nút preview có thể bị sai customization_id
   *
   * Nếu detect sai → remove nút preview và trigger render lại
   */
  function scheduleRevalidate(el) {
    setTimeout(() => {
      const img = el.querySelector('.AOV-CartDrawer-ItemImage img');
      const src = img?.src;

      const newId = getCustomizationIdFromSrc(src);
      if (!newId) return;

      const marker = el.querySelector('.tee-preview-design');
      if (!marker) return;

      const oldId = marker.dataset.customizationId;

      // nếu đúng thì thôi
      if (oldId === newId) return;

      // nếu sai → remove và trigger lại flow
      marker.remove();

      enhanceCartItemsDebounced();
    }, 1500);
  }

  /**
   * Extract customization_id từ image URL
   * Ví dụ:
   * cdn/.../customizations/{id}.jpg
   */
  function getCustomizationIdFromSrc(src) {
    if (!src) return null;

    const match = src.match(/customizations\/([a-f0-9-]+)\.(jpg|png|webp)/i);
    return match ? match[1] : null;
  }

  /**
   * Build map từ cart items:
   * customization_id → item
   */
  function buildCustomizationMap(cart) {
    const map = new Map();

    cart.items.forEach(item => {
      const id = item.properties?._customization_id;
      if (id) {
        map.set(id, item);
      }
    });

    return map;
  }

  /**
   * Wait cho element xuất hiện ổn định trong DOM
   */
  function waitForElementStable(selector, timeout = 3000) {
    return new Promise((resolve) => {
      const start = Date.now();

      function check() {
        const el = document.querySelector(selector);
        if (el && el.isConnected) return resolve(el);

        if (Date.now() - start > timeout) return resolve(null);

        requestAnimationFrame(check);
      }

      check();
    });
  }

  /**
   * ================= CORE LOGIC =================
   *
   * Loop qua từng cart item:
   * - Lấy image → extract customization_id
   * - So với cart data
   * - Inject preview button
   *
   * Handle các case:
   * - render chậm (retry)
   * - DOM reuse → id mismatch
   * - duplicate preview button
   */
  async function enhanceCartItems(retry = 0) {
    const drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    const cartItems = drawer.querySelectorAll(SELECTORS.item);

    // retry nếu item chưa render
    if (cartItems.length === 0 && retry < MAX_RETRY) {
      setTimeout(() => enhanceCartItems(retry + 1), 250);
      return;
    }

    if (cartItems.length === 0) return;

    const cart = await getCart();
    const customizationMap = buildCustomizationMap(cart);

    let hasUpdate = false;

    for (let i = 0; i < cartItems.length; i++) {
      const el = cartItems[i];

      // delay để đợi DOM ổn định
      await delay(80);

      const img = el.querySelector('.AOV-CartDrawer-ItemImage img');
      const src = img?.src;

      const customizationId = getCustomizationIdFromSrc(src);
      if (!customizationId) continue;

      const item = customizationMap.get(customizationId);
      if (!item) continue;

      // nếu preview button đã tồn tại nhưng sai id → remove
      const existing = el.querySelector(SELECTORS.marker);

      if (existing) {
        const currentId = existing.dataset.customizationId;

        if (currentId !== customizationId) {
          existing.remove();
        } else {
          continue;
        }
      }

      // create preview marker
      const marker = document.createElement('div');
      marker.className = 'tee-preview-design';
      marker.style.marginTop = '5px';
      marker.dataset.customizationId = customizationId;

      const content = el.querySelector(SELECTORS.itemContent);
      (content || el).appendChild(marker);

      // schedule revalidate để handle async image update
      scheduleRevalidate(el);

      hasUpdate = true;
    }

    // trigger event để TIB re-render preview
    if (hasUpdate) {
      document.dispatchEvent(new CustomEvent('shopify-event-cart-updated'));
    }
  }

  const enhanceCartItemsDebounced = debounceAsync(
    enhanceCartItems,
    DEBOUNCE_DELAY
  );

  /**
   * Observe changes trong cart drawer
   * → detect item add/remove/update
   */
  function startObserveItems(drawer) {
    if (isObservingItems) return;

    isObservingItems = true;

    itemObserver = new MutationObserver(() => {
      enhanceCartItemsDebounced();
    });

    itemObserver.observe(drawer, {
      childList: true,
      subtree: true
    });

    enhanceCartItemsDebounced();
  }

  function stopObserveItems() {
    if (itemObserver) {
      itemObserver.disconnect();
      itemObserver = null;
    }
    isObservingItems = false;
  }

  /**
   * Observe trạng thái open/close của cart drawer
   */
  function observeDrawer(root) {
    let drawerEl = null;

    function setupObserver(target) {
      if (drawerClassObserver) {
        drawerClassObserver.disconnect();
      }

      drawerClassObserver = new MutationObserver(() => {
        const isOpen = target.classList.contains(SELECTORS.openClass);

        if (isOpen) {
          startObserveItems(root);
        } else {
          stopObserveItems();
        }
      });

      drawerClassObserver.observe(target, {
        attributes: true,
        attributeFilter: ['class']
      });

      if (target.classList.contains(SELECTORS.openClass)) {
        startObserveItems(root);
      }
    }

    // tìm element drawer inner
    const findDrawerEl = () => {
      const el = root.querySelector('.AOV-CartDrawer');

      if (el && el !== drawerEl) {
        drawerEl = el;
        setupObserver(el);
      }
    };

    findDrawerEl();

    // observe khi drawer render lại
    const innerObserver = new MutationObserver(findDrawerEl);

    innerObserver.observe(root, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Init script:
   * - đợi drawer render
   * - attach observer
   */
  async function init() {
    const drawer = await waitForElementStable(SELECTORS.drawer);
    if (!drawer) return;

    observeDrawer(drawer);
  }

  // run khi DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

function updateAsyncEl() {
  if(Shopify.locale != 'en') return;

  const selector = '.tee-preview-button__text';
  const expected = 'Preview Design';

  function fix() {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.textContent.trim() !== expected) el.textContent = expected;
    });
  }

  new MutationObserver(fix).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  fix();
}

updateAsyncEl();